module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_are-797727a4237b4577a8057366353edb17.png";